import React, { useState } from "react";
import { useSelector } from "react-redux";
import { BackArrowIcon2, user_2 ,scrollxLogo} from "../../../../assets/icons";
import DashSetting from "../../../Setting/DashSetting";
import "./Navbar_render.css";

export default function Navbar_back_btn({ closeModal, nameShow }) {
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const project = useSelector((state) => state.project);

  return (
    <div className="w-full h-[64px] flex justify-between items-center renderNavContainer drop-shadow-2xl px-[5%]">
      <div className="">
        <div className=" flex items-center ">
          {/* <Link to="/dashboard" onClick={() => closeModal()}> */}
          <div className="flex items-center Syne text-xl font-extrabold tracking-wide text-[#dee3eb]"
            // onClick={() => closeModal()}
          >
            <img className=" w-[38px]" style={{ cursor: "pointer" }}
              src={BackArrowIcon2}
              alt=""
              onClick={() => closeModal()}
            />
            {/* </Link> */}
            <img className="pro_navabr_home2 mr-[-.2rem]" src={scrollxLogo} />
            ScrollX.io
          </div>
        </div>
      </div>
      <div className="ml-[-10%]">
        {/* <div style={{display:'flex', justifyContent:'center'}}><img className="nav_render_scrollx_icon" src={scrollx_icon} alt='' /></div> */}
        <div className="FontFamily-Avenir-reg text-base tracking-wide  flex items-center justify-center text-white">
          {nameShow ? "MY RENDERS" : project?.title?.toUpperCase()}
        </div>
      </div>
      <div className="">
        <div className="flex items-center justify-end ">
          {!nameShow && (
            <div>
              <img className="opacity-75 w-[25px]" onClick={() => setIsSettingOpen(true)} src={user_2}/>
              <div className="">
                <DashSetting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}